<template>
  <div class="view pa24">
    <div class="d-flex align-items-center">
      {{ $t('finance', 'status') }}：
      <div v-for="(item,index) in dateList"
           @click="currentDateIndex = item.date"
           :key="index"
           class="flex-c-c w80 h34 mr10 br5 hover_pointer"
           :class=" currentDateIndex == item.date ?  'bbule1 cblue trans2' : 'bDCDFE6 trans2' ">
          {{item.name}}
      </div>
      
      <el-date-picker
        v-model="pickerValue"
        class="mr10 "
        align="right"
        value-format="yyyy-MM-dd"
        type="daterange"
        :start-placeholder="$t('finance', 'startDate')"
        :end-placeholder="$t('finance', 'endDate')"
      />
      <el-button type="primary" @click="queryBossWithdrawals">{{ $t('finance', 'search') }}</el-button>
    </div>
    
    <commonTable
      :tableData="tableData"
      :loading="loading"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      :currentPage="currentPage"
      :total="total"
    >
      <template v-slot:table>
        <el-table-column
            prop="createdTime"
            align="center"
            :label="$t('finance', 'applicationTime')"
            show-overflow-tooltip
          />
        <el-table-column prop="amount" align="center" :label="$t('finance', 'applicationAmount')"/>
        <el-table-column prop="balance" align="center" :label="$t('finance', 'withdrawableAmount')" />
        <el-table-column prop="name" align="center" :label="$t('finance', 'withdrawalAccount')"/>
        <el-table-column prop="note" align="center" :label="$t('finance', 'remarkDescription')" />
        <el-table-column prop="approvalTime" align="center" :label="$t('finance', 'paymentTime')" />
        <el-table-column prop="forwardfNum" align="center" :label="$t('finance', 'status')">
            <template slot-scope="scope">
              <div class="cblue">
                <p class="cblue" v-if="scope.row.approvalStatus == 0">{{ $t('finance', 'waitingForPayment') }}</p>
                <p class="cblue" v-if="scope.row.approvalStatus == 1">{{ $t('finance', 'paymentSuccessful') }}</p>
                <p class="corange" v-if="scope.row.approvalStatus == 2">{{ $t('finance', 'rejected') }}</p>
                <p class="cblue" v-if="scope.row.approvalStatus == 3">{{ $t('finance', 'approvedPendingPayment') }}</p>
              </div>
            </template>
          </el-table-column>
      </template>
    </commonTable>

  </div>
</template>

<script>
import commonTable from "@/components/common/commonTable";
import { getDataTimeSec } from "@/utils";
import {  queryOrders,querySells,addBossWithdrawals,queryBossWithdrawals } from "@/api/financing";
import i18nMixin from "@/mixins/i18nMixin";

export default {
  name: "visitorData",
  mixins: [i18nMixin],
  components: {
    commonTable,
  },
  data() {
    return {
      pickerValue: "", //选择时间
      tableData: [],
      currentPage: 1, //当前页
      pageSize: 10, //显示条数
      loading: false, //表格加载
      total: 0, //总条数
      staffs: [],
      userId: "",
      sourcesId: "",
      authsId: "",
      phone: "",
      currentDateIndex:4,
      dialogTableVisible:false,
    };
  },
  computed: {
    dateList() {
      return [
        { id: 1, name: this.$t('finance', 'all'), date: 4 },
        { id: 2, name: this.$t('finance', 'waitingForPayment'), date: 0 },
        { id: 3, name: this.$t('finance', 'paymentSuccessful'), date: 1 },
        { id: 4, name: this.$t('finance', 'rejected'), date: 2 },
      ];
    }
  },
  filters: {
    getDataTimeSec(val) {
      return getDataTimeSec(val);
    },
  },
  created() {
    this.queryBossWithdrawals();
  },
  methods: {
    async queryBossWithdrawals() {
      let data = {
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        approvalStatus:this.currentDateIndex,
        startTime: this.pickerValue && `${this.pickerValue[0]} 00:00:00`,
        endTime: this.pickerValue && `${this.pickerValue[1]} 23:59:59`,
      };
      if(this.currentDateIndex == 4){
        data.approvalStatus = ''
      }
      try {
        this.loading = true;
        const result = await queryBossWithdrawals(data);
        this.loading = false;
        const { total, list } = result?.data.pageInfo;
        this.tableData = list;
        this.tableData.forEach(item=>{

        })
        this.total = total;
      } catch (error) {
        this.tableData = []
        this.loading = false;
        console.log(error);
      }
    },
    formatSeconds(value) {
      var theTime = parseInt(value);// 秒
      var theTime1 = 0;// 分
      var theTime2 = 0;// 小时
      if(theTime > 60) {
        theTime1 = parseInt(theTime/60);
        theTime = parseInt(theTime%60);
        if(theTime1 > 60) {
          theTime2 = parseInt(theTime1/60);
          theTime1 = parseInt(theTime1%60);
        }
      }
      var result = ""+parseInt(theTime)+"秒";
      if(theTime1 > 0) {
        result = ""+parseInt(theTime1)+"分"+result;
      }
      if(theTime2 > 0) {
        result = ""+parseInt(theTime2)+"小时"+result;
      }
      return result;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryBossWithdrawals();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryBossWithdrawals();
    },
    dialogClose(){
      this.dialogTableVisible = false
    },
    
  },
};
</script>

<style lang="scss" scoped>
</style>